"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.setToken = setToken;
exports.removeToken = removeToken;
exports.getStatus = getStatus;
exports.setStatus = setStatus;
exports.removeStatus = removeStatus;
exports.getUserName = getUserName;
exports.setUserName = setUserName;
exports.removeUserName = removeUserName;
exports.getPassword = getPassword;
exports.setPassword = setPassword;
exports.removePassword = removePassword;
exports["default"] = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var cookiePrefix = process.env.COOKIE_PREFIX || '';
var TokenKey = "".concat(cookiePrefix, "Admin-Token");
var StatusKey = "".concat(cookiePrefix, "user-status");
var userName = "".concat(cookiePrefix, "user-name");
var password = "".concat(cookiePrefix, "user-password");

function getToken() {
  return _jsCookie["default"].get(TokenKey);
}

function setToken(token) {
  return _jsCookie["default"].set(TokenKey, token);
}

function removeToken() {
  return _jsCookie["default"].remove(TokenKey);
}

function getStatus() {
  return _jsCookie["default"].get(StatusKey);
}

function setStatus(token) {
  return _jsCookie["default"].set(StatusKey, token);
}

function removeStatus() {
  return _jsCookie["default"].remove(StatusKey);
}

function getUserName() {
  return _jsCookie["default"].get(userName);
}

function setUserName(token) {
  return _jsCookie["default"].set(userName, token);
}

function removeUserName() {
  return _jsCookie["default"].remove(userName);
}

function getPassword() {
  return _jsCookie["default"].get(password);
}

function setPassword(token) {
  return _jsCookie["default"].set(password, token);
}

function removePassword() {
  return _jsCookie["default"].remove(password);
}

var _default = {
  getToken: getToken,
  setToken: setToken,
  removeToken: removeToken,
  getStatus: getStatus,
  setStatus: setStatus,
  removeStatus: removeStatus,
  getUserName: getUserName,
  setUserName: setUserName,
  removeUserName: removeUserName,
  getPassword: getPassword,
  setPassword: setPassword,
  removePassword: removePassword
};
exports["default"] = _default;